import React, { useCallback} from 'react';

import Lens from "../../icon/lens.svg"
import { injectIntl } from "react-intl";
import { useMemo } from 'react';


const ItemLibrary = (props) => {

  const openDetailHandler= useCallback((item) => {
    if(item.detail && item.detail.id ) props.onClick(item.detail)
  }, []);

  const svgHeart = useMemo(() => (<svg width="28" height="28" viewBox="0 0 28 28"><path d="M13.309,23.752l-1.64-1.493C5.845,16.978,2,13.495,2,9.22A6.16,6.16,0,0,1,8.22,3a6.772,6.772,0,0,1,5.089,2.364A6.772,6.772,0,0,1,18.4,3a6.16,6.16,0,0,1,6.22,6.22c0,4.275-3.845,7.758-9.669,13.051Z" /></svg>), [])
  const {item, favorite, disabled, showTooltip, hideTooltip, disablebByState, tooltip} = props;
  const itemDisabled= disabled || disablebByState;
  const noRequest = !!window.LIBRARY_NO_REQUEST;

  return (
    <li className={`itemLibrary ${favorite ? 'favorite' :''} ${disabled ? 'disabled' :''}`}>
        <div className="itemLibrary__imgWrappper" onClick={() => {openDetailHandler(item) }}>
            <span className="itemLibrary__lens"><img src={Lens}></img></span>
            <div className="itemLibrary__btnDetail">
                <img src={item.img}></img>
            </div>
        </div>
        <div className="itemLibrary__nameWrapper">
        <p className="itemLibrary__name"><strong>{item.name}</strong></p>
        {item.description && <p className="itemLibrary__description">{item.description}</p>}

          {!noRequest && (!itemDisabled?
          <button  className={`itemLibrary__btnPrefered ${favorite ? "active" :""}`} disabled={props.disabled} onClick={() => {props.toggleFavorite(item) }}>
            {svgHeart}
          </button> :
          <span  className={`itemLibrary__btnPrefered disabled`} data-tip={tooltip} data-html={true} disabled
            onMouseOver={(e) => showTooltip(e.currentTarget, tooltip)}
            onMouseOut={(e) => hideTooltip(e.currentTarget)}
            >
            {svgHeart}
          </span>
          )}

        </div>
    </li>
    )
}

export default injectIntl(ItemLibrary);